export enum ERouteUseMedicine {
  Drink = 'Uống',
  DissolveInMouth = 'Ngậm',
  Chew = 'Nhai',
  OralSwabbing = 'Rơ',
  NasalAndThroatInhalation = 'Xông mũi họng',
  PlaceUnderTongue = 'Đặt dưới lưỡi',
  HoldUnderTongue = 'Ngậm dưới lưỡi',
  IntramuscularInjection = 'Tiêm bắp',
  SubcutaneousInjection = 'Tiêm dưới da',
  IntradermalInjection = 'Tiêm trong da',
  IntravenousInjection = 'Tiêm tĩnh mạch',
  IntravenousInfusion = 'Tiêm truyền tĩnh mạch',
  JointCavityInjection = 'Tiêm vào ổ khớp',
  IntravitrealInjection = 'Tiêm nội nhãn cầu',
  VitreousInjection = 'Tiêm trong dịch kính của mắt',
  BodyCavityInjection = 'Tiêm vào các khoang của cơ thể',
  Injection = 'Tiêm',
  TumorArterialInjection = 'Tiêm động mạch khối u',
  NaturalCavityInjection = 'Tiêm vào khoang tự nhiên',
  TumorInjection = 'Tiêm vào khối u',
  InfusionTherapy = 'Truyền tĩnh mạch',
  GeneralInfusion = 'Tiêm truyền',
  Apply = 'Bôi',
  RubExternally = 'Xoa ngoài',
  SkinPatch = 'Dán trên da',
  SkinSpray = 'Xịt ngoài da',
  ExternalUse = 'Dùng ngoài',
  VaginalPlacement = 'Đặt âm đạo',
  RectalPlacement = 'Đặt hậu môn',
  RectalAndAnalEnema = 'Thụt hậu môn - trực tràng',
  Placement = 'Đặt',
  UterinePlacement = 'Đặt tử cung',
  Enema = 'Thụt',
  MistSpray = 'Phun mù',
  Inhalation = 'Dạng hít',
  InhalationPowder = 'Bột hít',
  GeneralSpray = 'Xịt',
  Nebulization = 'Khí dung',
  RespiratoryRoute = 'Đường hô hấp',
  NasalSpray = 'Xịt mũi',
  ThroatSpray = 'Xịt họng',
  NasalMedicine = 'Thuốc mũi',
  NasalDrops = 'Nhỏ mũi',
  EyeDrops = 'Nhỏ mắt',
  EyeOintment = 'Tra mắt',
  OphthalmicMedicine = 'Thuốc mắt',
  EarDrops = 'Nhỏ tai',
  SkinApplication = 'Áp ngoài da',
  CloseToTumor = 'Áp sát khối u',
  GasBottle = 'Bình khí lỏng hoặc nén',
  CompressedGasBottle = 'Bình khí nén',
  RectalApplication = 'Bôi trực tràng',
  CleanTongueCoating = 'Đánh tưa lưỡi',
  TumorImplantation = 'Cấy vào khối u',
  ExternalRadiation = 'Chiếu ngoài',
  Solution = 'Dung dịch',
  WashingSolution = 'Dung dịch rửa',
  DialysisSolution = 'Dung dịch thẩm phân',
  Spray = 'Phun',
  Bag = 'Túi',
  Suspension = 'Hỗn dịch',
  LyophilizedPowder = 'Bột đông khô để pha hỗn dịch'
}
